"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakeDataset = void 0;
const interfaces_1 = require("@buildcore/interfaces");
const Dataset_1 = require("./Dataset");
/**
 * Token Stake Dataset.
 */
class StakeDataset extends Dataset_1.DatasetClass {
    constructor() {
        super(...arguments);
        /**
         * Stake Token
         *
         * @param req Use {@link BuildcoreRequest} with data based on {@link TokenStakeRequest}
         * @returns
         */
        this.deposit = (req) => this.sendRequest(interfaces_1.WEN_FUNC.depositStake)(req);
        /**
         * Get stakes by member. Real time stream.
         * @param member
         * @param startAfter
         * @param limit
         * @returns
         */
        this.getByMemberLive = (member, startAfter, limit) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['member'],
                fieldValue: [member],
                operator: [interfaces_1.Opr.EQUAL],
                startAfter,
                limit,
                orderBy: ['expiresAt'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
    }
}
exports.StakeDataset = StakeDataset;
